import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useState } from 'react';
import Navbar from './components/Navbar';
import ScrollToTop from './components/ScrollToTop';
import Hero from './components/Hero';
import Hero2 from './components/Hero2';
import SCLProfile from './components/SCLprofile';
import Journey from './components/Journey';
import Globalfootprint from './components/Global_footprint';
import Directors from './components/Directors';
import Practices from './components/Practices';
import Commitment from './components/Commitment';
import Evolution from './components/Evolution';
import Capabilities from './components/Capabilities';
import Process from './components/Tech-Process';
import './App.css';
import Technology from './components/Technology';
import Collaboration from './components/Collabration';
import Manufacture from './components/Manufacture';
import Cast from './components/Cast';
import Machine from './components/Machine';
import Casting from './components/Casting';
import Machining from './components/Machining';
import Overview from './components/Overview';
import Vision from './components/Vision';
import Product from './components/Product';
import Dummy from './components/Dev';
import Awards from './components/Awards';
import AwardsArchive from './components/AwardsArchive';
import Certifications from './components/Certifications';
import AbtProducts from './components/AbtProducts';
import CustomerAwards from './components/CustomerAwards';
import OurCustomers from './components/OurCustomers';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import DirectorProfile from "./components/DirectorProfile";
import Solutions from './components/Solutions';
import Investors from './components/Investors';
import Commercial from './components/Commercial';
import Passenger from './components/Passenger';
import TwoWheelers from './components/TwoWheelers';
import Sustainability from './components/Sustainability';
import Environmental from './components/Environmental';
import SocialSustainability from './components/SocialSustainability';
import SolDesign from './components/Sol-Design';
import SolPrototyping from './components/Sol-Prototyping';
import SolEngineering from './components/Sol-Engineering';
import TechProcess from './components/Tech-Process';
import TechProduct from './components/Tech-Product';
import TechDigital from './components/Tech-Digital';
import CapResearch from './components/Cap-Research';
import CapManufacture from './components/Cap-Manufacture';
import CapQuality from './components/Cap-Quality';
import PeopleCareer from './components/Peo-Career';
import PeopleCulture from './components/Peo-Culture';
import Disclaimer from './components/Disclaimer';
import ContactUs from './components/Contactus';
import IGBCPressRelease from './components/IGBCPressRelease';

function HomeHero() {
  const [showSecond, setShowSecond] = useState(false);
  return (
    <section>
      {!showSecond ? (
        <Hero onFinish={() => setShowSecond(true)} />
      ) : (
        <Hero2 onFinish={() => setShowSecond(false)} />
      )}
      
      <AbtProducts />
      <CustomerAwards />
      <OurCustomers />
      <HeroSection />
      <Footer />
    </section>
  );
}

function App() {
  return (
    <div className="app-background">
      <div className="app-content">
        <Router>
          <ScrollToTop />
          <Navbar />

          <Routes>
            <Route path="/" element={<HomeHero />} />

            <Route path="/founder" element={<SCLProfile />} />
            <Route path="/journey" element={<Journey />} />
            <Route path="/footprint" element={<Globalfootprint />} />
            <Route path="/directors" element={<Directors />} />
            <Route path="/director/:slug" element={<DirectorProfile />} />
            <Route path="/practices" element={<Practices />} />
            <Route path="/commitment" element={<Commitment />} />
            <Route path="/products" element={<Product />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/awards/archive" element={<AwardsArchive />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/certifications" element={<Certifications />} />
<Route path="/press-release/igbc-platinum-rating" element={<IGBCPressRelease />} />
            <Route path="/solutions" element={<Solutions />} />

            <Route
              path="/customers"
              element={
                <>
                  <OurCustomers />
                  <Footer />
                </>
              }
            />

            <Route path="/capability-evolution" element={<Evolution title="Capability Evolution" />} />
            <Route path="/technology" element={<Technology />} />
            <Route path="/capabilities" element={<Capabilities title="Capabilities" />} />
            <Route path="/process-capabilities" element={<Process />} />
            <Route path="/randd-collabration" element={<Collaboration />} />
            <Route path="/manufacture" element={<Manufacture />} />
            <Route path="/casting" element={<Cast />} />
            <Route path="/machining-capacity" element={<Machine />} />
            <Route path="/qua-casting" element={<Casting />} />
            <Route path="/qua-machining" element={<Machining />} />
            <Route path="/investors" element={<Investors />} />

            <Route path="/overview" element={<Overview />} />
            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/Dev" element={<Dummy />} />
            <Route path="/commercial" element={<Commercial />} />
            <Route path="/passenger" element={<Passenger />} />
            <Route path="/twowheelers" element={<TwoWheelers />} />
          
            <Route path="/environmental" element={<Environmental />} />
            <Route path="/socialsustainability" element={<SocialSustainability />} />

            <Route path="/solutions/sol-design" element={<SolDesign />} />
            <Route path="/solutions/sol-prototyping" element={<SolPrototyping />} />
            <Route path="/solutions/sol-eng" element={<SolEngineering />} />

            <Route path="/technology/tech-process" element={<TechProcess />} />
            <Route path="/technology/tech-product" element={<TechProduct />} />
            <Route path="/technology/tech-digital" element={<TechDigital />} />

            <Route path="/capabilities/cap-research" element={<CapResearch />} />
            <Route path="/capabilities/cap-manufacture" element={<CapManufacture />} />
            <Route path="/capabilities/cap-quality" element={<CapQuality />} />

            <Route path="/peo-career" element={<PeopleCareer />} />
            <Route path="/peo-culture" element={<PeopleCulture />} />

            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/contactus" element={<ContactUs />} />
          </Routes>
        </Router>
      </div>
    </div>
  );
}

export default App;